'use strict';

var timeLogHelper = require('../../helper/timeLogHelper');

var Log = {
  componentWillMount: function () {
    this.mountStart = Date.now();
  },
  componentDidMount: function () {
    timeLogHelper.logComponentRender(this.props.controlTypeID, Date.now() - this.mountStart);
  },
  // componentWillUpdate: function () {
  //   this.updateStart = Date.now();
  // },
  // componentDidUpdate: function () {
  //   timeLogHelper.logComponentRender(this.props.controlTypeID, Date.now() - this.updateStart);
  // }
};

module.exports = Log;


// WEBPACK FOOTER //
// ./src/views/Mixin/Log.js